<template>
  <div>
    <div v-if="isInfluencerCell" class="if-cell">
      <el-image :src="profileImage" class="if-avatar" fit="cover" @error="onImgError" @click.native="openInfluencer">
        <div slot="error" class="if-avatar--error">
          <font-awesome-icon :icon="['far', 'user']" />
        </div>
      </el-image>

      <div class="if-meta">
        <div class="if-top">
          <span class="if-account" @click="openInfluencer">@{{ accountName }}</span>
          <span v-if="badge" class="if-badge">
            <font-awesome-icon :icon="['fas', 'badge-check']" />
          </span>
        </div>
        <div v-if="displayName" class="if-name" @click="openInfluencer">{{ displayName }}</div>
      </div>
    </div>

    <el-tooltip v-else-if="isEmptyValue" placement="top" :content="tooltipContent">
      <span class="na-hourglass">
        <font-awesome-icon :icon="['far', 'hourglass-half']" style="color: #ccc"/>
      </span>
    </el-tooltip>

    <span v-else>
      {{ formattedValue }}
    </span>
  </div>
</template>

<script>
export default {
  name: "reportInfluencerValueX",
  props: {
    column: { type: String, required: true },
    report_id: { type: [String, Number], required: true },
    ig_id: { type: [String, Number], default: null }, // 互換用（内部的にはtw_id）
    index: { type: Number, required: true },
    value: { required: false },
    type: { type: String, default: "" },
    sns_type: { type: String, default: "x" }
  },
  data() {
    return {
      imgFailed: false,
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    isInfluencerCell() {
      return this.column === "influencer" || this.type === "media_and_if";
    },
    isEmptyValue() {
      if (this.isInfluencerCell) return false;
      if (this.value && typeof this.value === "object") return true;
      return this.value === null || this.value === undefined || this.value === "";
    },
    formattedValue() {
      if (this.isEmptyValue) return "";
      let val = this.value;
      switch (this.type) {
        case 'number': case 'cost_setting': case 'refer':
          return this.addComma(val);
        case 'percent': case 'refer_percent':
          return this.formatPercent(val) + "%";
        case 'cost':
          return "¥" + this.addComma(val);
        default:
          return val;
      }
    },
    tooltipContent() {
      switch (this.type) {
        case 'number': case 'cost_setting': return '投稿一覧で編集可能です';
        case 'percent': return '投稿一覧で指標を編集することで自動算出されます';
        case 'cost': return '投稿一覧でコストを設定することで自動算出されます';
        case 'refer': case 'refer_percent': return '該当のデータが存在するインフルエンサーのみ表示されます';
        default: return 'データがありません';
      }
    },
    row() { return (this.value && typeof this.value === "object") ? this.value : {}; },
    influencer() { return this.row?.influencer || this.row || {}; },
    accountName() { return this.influencer.account_name || this.row.account_name || ""; },
    displayName() { return this.influencer.name || this.row.name || ""; },
    badge() {
      const b = this.influencer.badge ?? this.row.badge;
      return Number(b) === 1;
    },
    profileImage() {
      if (this.imgFailed) return this.s3BaseUrl ? `${this.s3BaseUrl}/userdata/img_error.png` : "";
      return this.influencer.profile_picture_url || this.row.profile_picture_url || "";
    }
  },
  methods: {
    addComma(val) {
      if (val === "" || val === null || val === undefined) return "";
      if (isNaN(val)) return val;
      const n = Number(val);
      return Number.isInteger(n)
          ? n.toLocaleString()
          : n.toLocaleString(undefined, { maximumFractionDigits: 2 });
    },
    onImgError() { this.imgFailed = true; },
    openInfluencer() {
      if (!this.accountName) return;
      // SNS種別を明示的に渡す
      this.$emit("openInfluencer", this.accountName, "twitter");
    },
    formatPercent(val) {
      if (val === "" || val === null || val === undefined || isNaN(val)) return val;
      return Math.round(Number(val) * 100) / 100;
    },
  },
};
</script>

<style scoped>
.if-cell { display: flex; align-items: center; gap: 10px; }
.na-hourglass { display: inline-flex; align-items: center; justify-content: center; }
.if-avatar { width: 34px; height: 34px; border-radius: 50%; cursor: pointer; }
.if-avatar--error { width: 34px; height: 34px; border-radius: 50%; display: flex; align-items: center; justify-content: center; background: #f2f2f2; color: #999; }
.if-meta { min-width: 0; }
.if-top { display: flex; align-items: center; gap: 6px; line-height: 1.1; }
.if-account { font-size: 12px; color: #333; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 220px; cursor: pointer; }
.if-name { font-size: 11px; color: #777; margin-top: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 240px; cursor: pointer; }
.if-badge { font-size: 12px; color: #1da1f2; } /* Xのブルー */
</style>